import React, { useState, useRef } from "react";
import useOnClickOutside from "use-onclickoutside";
import { injectIntl } from "react-intl";
import ChangeStatusModal from "../ChangeStatusModal";
import {
  DropDownWrapper,
  Wrapper,
  IconWrapper,
  Item,
  ItemIconWrapper,
  ItemIcon,
  TextWrapper,
  ItemHeader,
  ItemDesc,
  DropDown,
  More,
  ConfirmOverlay,
  ConfirmModal,
  ConfirmHeader,
  ConfirmButtons,
  ConfirmRemoveButton,
  ConfirmText,
  Cancel,
} from "./styled";

const MoreDropDown = injectIntl((props) => {
  const {
    numOfSelected,
    runActionButton,
    removeSelected,
    intl,
    dropDownLabel,
    actionButtons,
    hasDeletePermission,
    hasStatusChangePermission,
    changeStatusOfSelected,
    runEffect,
    effects,
    selected,
  } = props;
  const [open, setOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] = useState(false);

  const ref = useRef();

  const close = () => setOpen(false);

  useOnClickOutside(ref, close);

  const confirmChangeStatus = ({ connection }) => {
    setTimeout(() => {
      setIsChangeStatusModalOpen(false);
      changeStatusOfSelected({ connection });
      close();
    }, 180);
  };

  const ticketsHasSameFormAndStatus = effects["ticketsHasSameFormAndStatus"];

  return (
    <>
      <Wrapper>
        <IconWrapper
          className={open ? "clicked" : ""}
          onClick={() => setOpen(!open)}
        >
          <More>
            {intl.formatMessage({ id: dropDownLabel ? dropDownLabel : "More" })}
          </More>
        </IconWrapper>
        {open ? (
          <DropDownWrapper ref={ref}>
            <DropDown type="create">
              {actionButtons.length > 0 &&
                actionButtons.map((actionButton, i) => (
                  <Item
                    onClick={() => {
                      setTimeout(() => {
                        setOpen(false);
                        runActionButton(actionButton.effects);
                      }, 180);
                    }}
                    key={`actionButton-${i}`}
                  >
                    <ItemIconWrapper color={actionButton.color}>
                      <ItemIcon className={actionButton.icon} />
                    </ItemIconWrapper>
                    <TextWrapper>
                      <ItemHeader>{actionButton.label}</ItemHeader>
                      <ItemDesc>{actionButton.description}</ItemDesc>
                    </TextWrapper>
                  </Item>
                ))}
              {hasStatusChangePermission && ticketsHasSameFormAndStatus && (
                <Item onClick={() => setIsChangeStatusModalOpen(true)}>
                  <ItemIconWrapper color="success">
                    <ItemIcon className="fa-solid fa-arrow-right" />
                  </ItemIconWrapper>
                  <TextWrapper>
                    <ItemHeader>
                      {intl.formatMessage({
                        id: "ChangeStatusModal.changeStatus",
                      })}
                    </ItemHeader>
                    <ItemDesc>
                      {intl.formatMessage({
                        id: "MoreDropDown.changeStatus.description",
                      })}
                    </ItemDesc>
                  </TextWrapper>
                </Item>
              )}
              {hasDeletePermission && (
                <Item onClick={() => setIsRemoveModalOpen(true)}>
                  <ItemIconWrapper color="danger">
                    <ItemIcon className="fal fa-trash" />
                  </ItemIconWrapper>
                  <TextWrapper>
                    <ItemHeader>
                      {intl.formatMessage({ id: "Tickets.Remove" })}
                    </ItemHeader>
                    <ItemDesc>
                      {intl.formatMessage({ id: "Tickets.RemoveSelected" })}
                    </ItemDesc>
                  </TextWrapper>
                </Item>
              )}
            </DropDown>
          </DropDownWrapper>
        ) : (
          ""
        )}
      </Wrapper>
      {isChangeStatusModalOpen && (
        <ChangeStatusModal
          numOfSelected={numOfSelected}
          cancel={() => setIsChangeStatusModalOpen(false)}
          confirm={confirmChangeStatus}
          runEffect={runEffect}
          effects={effects}
          selected={selected}
        />
      )}
      {isRemoveModalOpen && (
        <ConfirmOverlay>
          <ConfirmModal>
            <ConfirmHeader>
              {intl.formatMessage({ id: "Tickets.RemoveHeading" })}
            </ConfirmHeader>
            <ConfirmText>
              <strong>{numOfSelected}</strong>{" "}
              {intl.formatMessage({ id: "Tickets.RemoveDescription" })}
            </ConfirmText>
            <ConfirmButtons>
              <Cancel onClick={() => setIsRemoveModalOpen(false)}>
                {intl.formatMessage({ id: "Cancel" })}
              </Cancel>
              <ConfirmRemoveButton
                onClick={() => {
                  setTimeout(() => {
                    setIsRemoveModalOpen(false);
                    setOpen(false);
                    removeSelected();
                  }, 180);
                }}
              >
                {intl.formatMessage({ id: "Remove" })}
              </ConfirmRemoveButton>
            </ConfirmButtons>
          </ConfirmModal>
        </ConfirmOverlay>
      )}
    </>
  );
});

export default MoreDropDown;
